import {
  Add,
  ArrowBack,
  ArrowForward,
  Delete,
  Edit,
  MoreVert,
} from "@mui/icons-material";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Pagination,
  PaginationItem,
  Paper,
  Snackbar,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import { useLayoutEffect } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomDataGrid from "../CustomComponents/CustomDataGrid";
import CustomDateField from "../CustomComponents/CustomDateField";
import CustomDropDown from "../CustomComponents/CustomDropDown";
import CustomTextField from "../CustomComponents/CustomTextField";
import NoDataFound from "../CustomComponents/NoDataFound";
import { ChequeReturnReducerAction } from "../Store/ChequeReturnReducer";
import ChequeReturnInfo from "./ChequeReturnInfo";
import store from "./../Store/index";
import axios from "axios";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import { useRef } from "react";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";

const ChequeReturnList = () => {
  //importing hook
  const dispatch = useDispatch();

  //Selectors from redux store
  const formData = useSelector((state) => state.chequeReturn.data);
  const datarows = useSelector((state) => state.chequeReturn.gridRows);
  const saveBtnDisable = useSelector(
    (state) => state.chequeReturn.saveBtnDisable
  );
  const gridPaginationData = useSelector(
    (state) => state.chequeReturn.gridPaginationData
  );
  const filteredFormData = useSelector(
    (state) => state.chequeReturn.filterData
  );
  const userName = useSelector((state) => state.branch.userName);

  const [open, setOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  const [dlgbtnName, setDlgBtnName] = useState("NEXT");
  const [dlgInputMode, setDlgInputMode] = useState(false);
  const [chequeNumErrorMsg, setChequeNumErrorMsg] = useState(
    "Please Enter Cheque Number"
  );
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogTitleMessage, setDialogTitleMessage] = useState("");
  const [chequeRealisedErrorDialogOpen, setChequeRealisedErrorDialogOpen] =
    useState(false);
  const [
    chequeRealisedErrorDialogMessage,
    setChequeRealisedErrorDialogMessage,
  ] = useState("");

  const [deleteOperationActive, setDeleteOperationActive] =
    React.useState(false);

  //shortcut key

  const addRowRef = useRef(null);
  const saveRef = useRef(null);
  const cancelRef = useRef(null);
  const okRef = useRef(null);
  const cancelDialogRef = useRef(null);
  const chequeRealisedOkRef = useRef(null);
  const yesRef = useRef(null);

  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "chequeReturnList",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    if (event.key === "Escape" || event.keyCode === 27) {
      // on escape press close the dialog.
      closeDialog();
    }
    if (event.ctrlKey) {
      if (charCode === "a") {
        addRowRef.current.click();
      } else if (charCode === "s") {
        saveRef.current.click();
      } else if (charCode === "q") {
        cancelRef?.current?.click();
        cancelDialogRef?.current?.click();
      } else if (charCode === "k") {
        okRef?.current?.click();
        chequeRealisedOkRef?.current?.click();
      } else if (charCode === "y") {
        yesRef.current.click();
      }
    }
  };

  //Input Validtion
  const returnReasonValid =
    formData.returnReason !== undefined &&
    formData.returnReason !== "" &&
    formData.returnReason !== null;
  const chargesValid =
    formData.charges !== undefined &&
    formData.charges !== null &&
    formData.charges !== "" &&
    formData.charges === 0 &&
    formData.charges !== "0";
  const chequeNumValid =
    formData.chequeNum !== undefined &&
    formData.chequeNum !== "" &&
    formData.chequeNum !== null;
  const voucherNumValid =
    formData.voucherNum !== undefined &&
    formData.voucherNum !== "" &&
    formData.voucherNum !== null;
  //Has Error
  const returnReasonHasError = formData.returnReasonError && !returnReasonValid;
  const voucherNumHasError = formData.voucherNumTouch && !voucherNumValid;
  const chargesHasError = formData.chargesError && !chargesValid;
  const chequeNumHasError =
    (formData.chequeNumError && !chequeNumValid) || formData.chequeNumError;

  const columns = [
    {
      field: "addRecord",
      headerName: "",
      headerAlign: "center",
      align: "left",
      flex: 50,
      hideable: false,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return !params.value ? (
          <Tooltip title="Ctrl+M" placement="right">
            <IconButton size="small">
              <Edit
                fontSize="small"
                sx={{ color: "#004A92", fontWeight: 700 }}
                onClick={() => onRowEditClick(params.row)}
              />
            </IconButton>
          </Tooltip>
        ) : (
          <LoadActionBtn
            record={params.row}
            onMoreActionsClick={(value, record) =>
              onMoreActionBtnClick(value, record)
            }
          />
        );
      },
    },
    {
      field: "chequeNum",
      headerName: "Cheque Number",
      headerAlign: "center",
      align: "left",
      flex: 200,
      hideable: false,
    },
    {
      field: "voucherNum",
      headerName: "Voucher Number",
      headerAlign: "center",
      align: "left",
      flex: 200,
      hideable: false,
    },
    {
      field: "chequeDate",
      headerName: "Cheque Date",
      headerAlign: "center",
      align: "right",
      flex: 150,
      hideable: false,
      sortable: false,
      filterable: false,
    },
    {
      field: "applicationNum",
      headerName: "Application Number",
      headerAlign: "center",
      align: "left",
      flex: 200,
      hideable: false,
    },
    {
      field: "chequeAmt",
      headerName: "Cheque Amount",
      headerAlign: "center",
      align: "right",
      flex: 150,
      hideable: false,
      renderCell: (params) => {
        return params.value === "0"
          ? 0
          : parseInt(params.value).toLocaleString("en-IN");
      },
    },
    {
      field: "returnReason",
      headerName: "Return Reason",
      headerAlign: "center",
      align: "left",
      flex: 200,
      hideable: false,
    },
    {
      field: "charges",
      headerName: "Charges",
      headerAlign: "center",
      align: "right",
      hideable: false,
      flex: 150,
      renderCell: (params) => {
        return params.value === "0"
          ? 0
          : parseInt(params.value).toLocaleString("en-IN");
      },
    },
  ];

  const [gridColumns, setGridColumns] = React.useState(columns);

  const [rows, setRows] = React.useState([]);
  const [accordianOpen, setAccordianOpen] = React.useState(true);
  const [page, setPage] = React.useState(1);
  const rowsPerPage = 10;
  const [totalPageCount, setTotalPageCount] = React.useState(0);
  const [totalRowsCount, setTotalRowsCount] = React.useState(0);

  // max value 1200 -> mobile.
  const [deviceMode, setDeviceMode] = React.useState("");
  const deviceModeValue = useMediaQuery("(max-width:1200px)");

  //SnackBar Handler
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [snackBarState, setSnackBarState] = React.useState({
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);

  useEffect(() => {
    // true -> mobile or tab, false -> desktop
    let SnackPosition = {
      vertical: deviceModeValue ? "top" : "bottom",
      horizontal: deviceModeValue ? "right" : "left",
    };
    setSnackBarState(SnackPosition);
  }, []);

  useEffect(() => {
    setDeviceMode(deviceModeValue ? "MOBILE" : "DESKTOP");
    setRows([...datarows].slice(0, 10));
    setTotalPageCount(
      datarows.length % 10 !== 0
        ? Number(Number((datarows.length / 10).toFixed()) + 1)
        : Number(Number((datarows.length / 10).toFixed()))
    );
    setTotalRowsCount(datarows.length);
    // this is for mobile ->  value  + 1;
    setPage(gridPaginationData.lastActivePage + 1);
    if (gridPaginationData.lastActivePage !== 0 && deviceMode === "MOBILE") {
      // in case of mobile if page is not first navigate to that page using auto call of handle change.
      // in this case event be null.
      handlePageChange(null, gridPaginationData.lastActivePage + 1);
    }
  }, [datarows, saveBtnDisable]);

  useLayoutEffect(() => {}, [saveBtnDisable]);

  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };

  const handlePageChange = (event, newPage) => {
    let offset = (newPage - 1) * rowsPerPage;
    setPage(newPage);
    setRows([...datarows].slice(offset, offset + rowsPerPage));
    const currentPage = { lastActivePage: newPage };
    dispatch(ChequeReturnReducerAction.updateGridPaginationData(currentPage));
  };

  const onMoreActionBtnClick = (value, record) => {
    // get the latest records.
    let latestRecords = store.getState().chequeReturn.gridRows;
    switch (value) {
      case "Edit":
        onRowEditClick(record);
        break;
      case "Delete":
        setDeleteOperationActive(true);
        setTimeout(() => {
          let rowsData = [...latestRecords];
          // in case of multiple records for same voucher -> then revert all the records from grid.
          let filteredData = rowsData.filter(
            (row) => row.voucherNum !== record.voucherNum
          );
          dispatch(ChequeReturnReducerAction.updateGridRows([...filteredData]));
          if (deviceMode === "MOBILE") {
            let pageNumberValue =
              filteredData.length % 10 === 0
                ? filteredData.length / 10 - 1
                : Math.floor(filteredData.length / 10);
            handlePageChange(null, pageNumberValue);
          } else {
            // desktop -> 5 records per page.
            // check the page number.
            let pageNumberValue =
              filteredData.length % 5 === 0
                ? filteredData.length / 5 - 1
                : Math.floor(filteredData.length / 5);
            onGridPageChange(pageNumberValue);
          }
          setTimeout(() => {
            setDeleteOperationActive(false);
          }, 1000);
        }, 100);

        break;

      default:
        break;
    }
  };

  const onDlgOkClick = () => {
    if (!dlgInputMode) {
      const voucherNumValue = formData.voucherNum;
      const updatedRecord = { ...formData };
      let recordsData = [...datarows];
      let updateRows = recordsData.map((record) => {
        if (record.voucherNum === voucherNumValue) {
          const recordData = {
            ...record,
            returnReason: updatedRecord.returnReason,
            returnReasonCode: updatedRecord.returnReasonCode,
            chequeDate: dayjs(updatedRecord.chequeDate).format("DD/MM/YYYY"),
          };
          return recordData;
        }
        return record;
      });
      dispatch(ChequeReturnReducerAction.updateGridRows([...updateRows]));
    } else {
      let rowsData = [...datarows];
      let record = { ...formData };
      const records = record.chequeNumRecords;
      const voucherNums = [...records].map((record) => record.voucherNum);
      const filteredRecords = rowsData.filter((existRecord) =>
        voucherNums.includes(existRecord.voucherNum)
      );
      // checking for duplicate and if not exist add record.
      if (filteredRecords.length === 0) {
        const updatedRecords = records.map((row) => {
          let currentRow = { ...row };
          currentRow.addRecord = true;
          currentRow.id =
            row.chequeNum + "-" + row.applicationNum + "-" + row.voucherNum;
          currentRow.chequeDate = dayjs(record.chequeDate).format("DD/MM/YYYY");
          currentRow.returnReason = record.returnReason;
          currentRow.returnReasonCode = record.returnReasonCode;
          return currentRow;
        });
        rowsData = rowsData.concat([...updatedRecords]);
        dispatch(ChequeReturnReducerAction.updateGridRows([...rowsData]));
      } else {
        setMessage("Cheque Number is Already Added.");
        setAlertType("error");
        openAlertHandler();
      }

      if (deviceMode === "MOBILE") {
        let pageNumberValue =
          rowsData.length % 10 === 0
            ? rowsData.length / 10 - 1
            : Math.floor(rowsData.length / 10);
        handlePageChange(null, pageNumberValue);
      } else {
        // desktop -> 5 records per page.
        // check the page number.
        let pageNumberValue =
          rowsData.length % 5 === 0
            ? rowsData.length / 5 - 1
            : Math.floor(rowsData.length / 5);
        onGridPageChange(pageNumberValue);
      }
    }

    closeDialog();
  };

  const closeDialog = () => {
    setOpen(false);
    setTimeout(() => {
      setDlgBtnName("NEXT");
      setChequeNumErrorMsg("");
      dispatch(ChequeReturnReducerAction.resetValues(true));
      dispatch(ChequeReturnReducerAction.updateReturnReasonTouchHandler(false));
      dispatch(ChequeReturnReducerAction.updateBranchTouchHandler(false));
      dispatch(ChequeReturnReducerAction.updateVoucherNumTouchHandler(false));
      dispatch(ChequeReturnReducerAction.updateChequeNumErrorHandler(false));
    }, 1000);
  };

  const rowDoubleClickHandler = (event) => {
    // Do nothing.
  };

  const getSelectedBranchCode = (branchValue) => {
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchCodeValue = branchWithCodes.find((branch) => {
      return branch.label === branchValue;
    });
    return branchCodeValue.code;
  };

  const onRowEditClick = async (row) => {
    // reload voucher nums based on selected checque number before edit.
    try {
      const branchCodeValue = getSelectedBranchCode(
        filteredFormData.branchValue
      );
      const response = await axios.post("/cheque/getVoucherNum", {
        chequeNum: row.chequeNum,
        branch: filteredFormData.branchValue,
        branchCode: branchCodeValue,
        voucherDate: dayjs(new Date(filteredFormData.voucherDate)).format(
          "MM/DD/YYYY"
        ),
      });
      let responseModelData = response.data;
      const voucherNums = responseModelData.voucherNumList;
      dispatch(ChequeReturnReducerAction.updateVoucherNumArray(voucherNums));
      setDlgBtnName("OK");
      // get the return reason value before reset.
      const returnReasonArrayValues = { ...formData }.returnReasonArray;
      var record = { ...row };
      // get the latest records & filter the records based on edited row voucher num.
      const latestRecords = store.getState().chequeReturn.gridRows;
      const currentEditVoucherNumRows = [...latestRecords].filter(
        (row) => row.voucherNum === record.voucherNum
      );

      const chequeAmt = Number(
        [...currentEditVoucherNumRows]
          .map((row) => Number(row.chequeAmt))
          .reduce((a, b) => a + b)
      );
      const charges = Number(
        [...currentEditVoucherNumRows]
          .map((row) => Number(row.charges))
          .reduce((a, b) => a + b)
      );
      const appNum = [...currentEditVoucherNumRows]
        .map((row) => row.applicationNum + ", ")
        .reduce((a, b) => a + b);

      record.applicationNum = appNum;
      record.chequeAmt = chequeAmt;
      record.charges = charges;
      // update the date format.
      var chequeDateString = record.chequeDate;
      var dateParts = chequeDateString.split("/");

      // month is 0-based, that's why we need dataParts[1] - 1
      var chequeDateObject = new Date(
        +dateParts[2],
        dateParts[1] - 1,
        +dateParts[0]
      );
      record.chequeDate = dayjs(chequeDateObject);
      record.voucherNumArray = [...voucherNums];
      record.returnReasonArray = returnReasonArrayValues;
      dispatch(ChequeReturnReducerAction.updateValues(record));
      setDlgInputMode(false);
      setOpen(true);
    } catch (error) {
      setMessage("Cheque Number related Voucher Numbers Load Failed.");
      setAlertType("error");
      openAlertHandler();
      console.log(error);
      throw Error(error);
    }
  };

  const onGridPageChange = (newPage) => {
    const currentPage = { lastActivePage: newPage };
    dispatch(ChequeReturnReducerAction.updateGridPaginationData(currentPage));
  };

  const onSaveButtonClickHandler = async () => {
    setDialogOpen(false);
    try {
      const branchWithCodes = GetBranchDetailsWithCode();
      const branchCodeValue = branchWithCodes.find((branch) => {
        return branch.label === filteredFormData.branchValue;
      });

      // get the latest records for save.
      const latestRecords = store.getState().chequeReturn.gridRows;
      const recordsData = latestRecords.map((row) => {
        // update the date format.
        let recordValue = { ...row };
        let chequeDateString = recordValue.chequeDate;
        let dateParts = chequeDateString.split("/");

        // month is 0-based, that's why we need dataParts[1] - 1
        let chequeDateObject = new Date(
          +dateParts[2],
          dateParts[1] - 1,
          +dateParts[0]
        );
        recordValue.chequeDate = dayjs(chequeDateObject);
        recordValue.branchCode = branchCodeValue.code;
        recordValue.createdBy = userName;
        recordValue.lastModifiedBy = userName;
        return recordValue;
      });
      const isChequesRealisedResponse = await axios.post(
        "/cheque/isChequesRealised",
        {
          chequeReturnList: recordsData,
        }
      );
      if (isChequesRealisedResponse.status === 200) {
        const response = await axios.post("/cheque/insertChequeReturn", {
          chequeReturnList: recordsData,
        });
        let records = [...response.data].map((row) => {
          let recordValue = { ...row };
          recordValue.id = recordValue.chequeNum;
          recordValue.chequeDate = dayjs(recordValue.chequeDate).format(
            "DD/MM/YYYY"
          );
          return recordValue;
        });
        dispatch(ChequeReturnReducerAction.updateGridRows([...records]));
        setMessage("Cheque Return Saved Successfully.");
        setAlertType("success");
        openAlertHandler();
        setTimeout(() => {
          dispatch(ChequeReturnReducerAction.resetFilterValues());
          dispatch(ChequeReturnReducerAction.updateBranchTouchHandler(false));
          dispatch(
            ChequeReturnReducerAction.updateVoucherDateTouchHandler(false)
          );
          dispatch(ChequeReturnReducerAction.updateShowCheckReturnList(false));
          dispatch(ChequeReturnReducerAction.resetGridRows());
          dispatch(ChequeReturnReducerAction.updateSaveBtnDisable(false));
        }, 3000);
      } else if (isChequesRealisedResponse.status === 206) {
        setChequeRealisedErrorDialogMessage(isChequesRealisedResponse.data);
        setChequeRealisedErrorDialogOpen(true);
      }
    } catch (error) {
      dispatch(ChequeReturnReducerAction.updateSaveBtnDisable(false));
      setMessage("Cheque Return Save Failed.");
      setAlertType("error");
      openAlertHandler();
      console.log(error);
    }
  };

  const onChangeChequeNumber = async () => {
    const newValue = formData.chequeNum;
    setChequeNumErrorMsg(
      newValue === null || newValue === undefined || newValue === ""
        ? "Please Enter Cheque Number"
        : newValue.length > 6 ||
          newValue.length < 6 ||
          String(newValue).includes(".") ||
          Number(newValue) < 0 ||
          !/^\d+$/.test(newValue)
        ? "Please Enter Valid Cheque Number"
        : ""
    );
    if (
      formData.chequeNum !== "" &&
      formData.chequeNum !== null &&
      formData.chequeNum !== undefined &&
      formData.chequeNum.length === 6 &&
      !String(formData.chequeNum).includes(".") &&
      Number(formData.chequeNum) > 0 &&
      /^\d+$/.test(newValue)
    ) {
      setChequeNumErrorMsg("");

      try {
        const branchCodeValue = getSelectedBranchCode(
          filteredFormData.branchValue
        );
        const response = await axios.post("/cheque/getVoucherNum", {
          chequeNum: formData.chequeNum,
          branch: filteredFormData.branchValue,
          branchCode: branchCodeValue,
          voucherDate: dayjs(new Date(filteredFormData.voucherDate)).format(
            "MM/DD/YYYY"
          ),
        });
        let responseModelData = response.data;
        dispatch(
          ChequeReturnReducerAction.updateVoucherNumArray(
            responseModelData.voucherNumList
          )
        );
        if (responseModelData.status) {
          // true means voucher nums loaded successfully.
          setMessage(responseModelData.message);
          setAlertType("success");
          openAlertHandler();
        } else {
          // valiation error exists.
          setMessage(responseModelData.message);
          setAlertType("error");
          openAlertHandler();
          setChequeNumErrorMsg(responseModelData.message);
          dispatch(ChequeReturnReducerAction.updateChequeNumErrorHandler(true));
          dispatch(ChequeReturnReducerAction.resetValues(false));
          dispatch(ChequeReturnReducerAction.updateChequeNumber(newValue));
        }
      } catch (error) {
        setMessage("Cheque Number related Voucher Numbers Load Failed.");
        setAlertType("error");
        openAlertHandler();
        console.log(error);
      }
    } else {
      setChequeNumErrorMsg("Please Enter Valid Cheque Number");
      dispatch(ChequeReturnReducerAction.resetValues(true));
      dispatch(ChequeReturnReducerAction.updateChequeNumErrorHandler(true));
    }
  };

  const handleDialogClose = () => {
    dispatch(ChequeReturnReducerAction.updateSaveBtnDisable(false));
    setDialogOpen(false);
  };

  const openAlertDialog = () => {
    setDialogMessage("Are you sure want to return cheque(s)?");
    setDialogTitleMessage("Confirmation");
    setDialogOpen(true);
  };

  const onChangeVoucherNum = async (value) => {
    dispatch(ChequeReturnReducerAction.updateVoucherNum(value));
    const currentChequeNum = formData.chequeNum;
    if (value && value !== "") {
      // validation cheque whether added to return grid already.
      // check for duplicates.
      // get the latest records for save.
      const latestRecords = store.getState().chequeReturn.gridRows;
      const filteredRecords = latestRecords.filter(
        (row) => row.voucherNum === value
      );

      if (filteredRecords.length > 0) {
        setChequeNumErrorMsg("Cheque Number Already Entered for Return");
        dispatch(ChequeReturnReducerAction.updateChequeNumErrorHandler(true));
        dispatch(ChequeReturnReducerAction.resetValues(false));
        dispatch(
          ChequeReturnReducerAction.updateChequeNumber(formData.chequeNum)
        );
        return;
      } else {
        // get the return reason value before reset.
        const returnReasonArrayValues = { ...formData }.returnReasonArray;
        const voucherNums = { ...formData }.voucherNumArray;
        const branchCodeValue = getSelectedBranchCode(
          filteredFormData.branchValue
        );
        const response = await axios.post(
          "/cheque/getFileReceiptDataByChequeNum",
          {
            chequeNum: currentChequeNum,
            branch: filteredFormData.branchValue,
            branchCode: branchCodeValue,
            fileReceiptVoucherNum: value,
            voucherDate: dayjs(new Date(filteredFormData.voucherDate)).format(
              "MM/DD/YYYY"
            ),
          }
        );
        if (response.data.status !== "PARTIAL_CONTENT") {
          let records = response.data.chequeReturn;
          dispatch(ChequeReturnReducerAction.updateChequeNumRecords(records));
          const chequeAmt = Number(
            [...records]
              .map((row) => Number(row.chequeAmt))
              .reduce((a, b) => a + b)
          );
          const charges = Number(
            [...records]
              .map((row) => Number(row.charges))
              .reduce((a, b) => a + b)
          );
          const appNum = [...records]
            .map((row) => row.applicationNum + ", ")
            .reduce((a, b) => a + b);
          let record = { ...records[0] };
          record.addRecord = true;
          record.id = records[0]?.chequeNum;
          record.returnReasonArray = returnReasonArrayValues;
          record.voucherNumArray = voucherNums;
          record.applicationNum = appNum;
          record.chequeAmt = chequeAmt;
          record.charges = charges;
          // validate return reason.
          if (
            record.returnReason === null ||
            record.returnReason === undefined ||
            record.returnReason === ""
          ) {
            dispatch(
              ChequeReturnReducerAction.updateReturnReasonTouchHandler(true)
            );
          }
          dispatch(ChequeReturnReducerAction.updateValues(record));
          dispatch(
            ChequeReturnReducerAction.updateChequeNumErrorHandler(false)
          );
          dispatch(
            ChequeReturnReducerAction.updateVoucherNumTouchHandler(false)
          );
          setDlgBtnName("OK");
          setMessage("Cheque Data loaded Successfully.");
          setAlertType("success");
          openAlertHandler();
        }

        if (response.data.status === "PARTIAL_CONTENT") {
          setMessage(response.data.messsage);
          setAlertType("error");
          openAlertHandler();
          setChequeNumErrorMsg(response.data.messsage);
          dispatch(ChequeReturnReducerAction.updateChequeNumErrorHandler(true));
          dispatch(ChequeReturnReducerAction.resetValues(false));
          dispatch(
            ChequeReturnReducerAction.updateChequeNumber(currentChequeNum)
          );
        }
      }
    } else {
      // on voucher num remove.
      dispatch(ChequeReturnReducerAction.updateVoucherNumTouchHandler(true));
      dispatch(ChequeReturnReducerAction.resetValues(false));
      dispatch(ChequeReturnReducerAction.updateChequeNumber(currentChequeNum));
    }
  };

  return (
    <React.Fragment>
      <AccordianContainer
        id="accord"
        title="Cheque Return Information"
        initialOpen={true}
        sx={{ margin: "8px !important" }}
      >
        <Box sx={{ float: "right" }}>
          <Tooltip title="Ctrl+A" placement="top">
            <Button
              size="small"
              sx={{ marginBottom: "2px" }}
              variant="contained"
              disabled={open}
              onClick={() => {
                setOpen(true);
                setDlgInputMode(true);
              }}
              ref={addRowRef}
            >
              {/* <Add fontSize="small" /> */}
              Add
            </Button>
          </Tooltip>
          <Tooltip title="Ctrl+S" placement="top">
            <Button
              sx={{
                marginLeft: "1rem",
              }}
              variant="contained"
              disabled={
                saveBtnDisable ||
                (deviceMode === "MOBILE"
                  ? rows.length === 0
                  : datarows.length === 0)
              }
              onClick={() => {
                dispatch(ChequeReturnReducerAction.updateSaveBtnDisable(true));
                setTimeout(() => {
                  openAlertDialog();
                }, 1000);
              }}
              ref={saveRef}
            >
              SAVE
            </Button>
          </Tooltip>
        </Box>

        {useMediaQuery("(min-width:1200px)") && (
          <CustomDataGrid
            noDataMessage="No Data."
            noDataOnFilterMessage="No Data on Applied Filter."
            rows={datarows}
            // gridHeight={
            //   datarows.length < 5 && datarows.length !== 0
            //     ? datarows.length * 40 + 130
            //     : 330
            // }
            gridHeight={330}
            columns={gridColumns}
            loading={deleteOperationActive}
            rowHeight={40}
            pageSize={10}
            pageSizeOptions={[10]}
            pageValue={gridPaginationData.lastActivePage}
            gridLazyLoad={onGridPageChange}
            rowDoubleClickHandler={rowDoubleClickHandler}
            onSortModelChange={() => {}}
          />
        )}
        {useMediaQuery("(max-width:1200px)") && (
          <React.Fragment>
            <Grid
              container
              item
              direction="row"
              alignItems="flex-end"
              justifyContent="flex-end"
              sx={{ height: "60px", bgcolor: "white" }}
            >
              {totalRowsCount > 10 && (
                <Typography
                  sx={{
                    mr: 2,
                    color: "#004A92",
                    fontWeight: 700,
                  }}
                >
                  {"Page Max Records : " + rowsPerPage}
                </Typography>
              )}
              <Typography
                padding="1px"
                sx={{ color: "#004A92", fontWeight: 700 }}
              >
                {"Total Records : " + totalRowsCount}
              </Typography>
              <Pagination
                count={totalPageCount}
                color="primary"
                onChange={handlePageChange}
                page={page}
                renderItem={(item) => (
                  <PaginationItem
                    slots={{ previous: ArrowBack, next: ArrowForward }}
                    {...item}
                  />
                )}
              />
            </Grid>
            <Grid container>
              <Box
                sx={{
                  height: accordianOpen
                    ? window.innerHeight - 540
                    : window.innerHeight - 250,
                  overflow: "auto",
                  flex: "1 auto",
                }}
              >
                {rows.map((row, index) => (
                  <React.Fragment>
                    <Grid container direction="column" sx={{ flex: "1 auto" }}>
                      <Card>
                        <CardHeader
                          subheader={"Cheque Number : " + row.chequeNum}
                          subheaderTypographyProps={{
                            color: "#004A92",
                            fontWeight: "700",
                          }}
                          action={
                            <React.Fragment>
                              {!row.addRecord ? (
                                <IconButton size="small">
                                  <Edit
                                    fontSize="small"
                                    sx={{ color: "#004A92", fontWeight: 700 }}
                                    onClick={() => onRowEditClick(row)}
                                  />
                                </IconButton>
                              ) : (
                                <LoadActionBtn
                                  record={row}
                                  onMoreActionsClick={(value, record) =>
                                    onMoreActionBtnClick(value, record)
                                  }
                                />
                              )}
                            </React.Fragment>
                          }
                          sx={{
                            textAlign: "left",
                            padding: "16px 16px 0px 16px !important",
                          }}
                        />
                        <CardContent sx={{}}>
                          <Grid
                            container
                            item
                            direction="column"
                            alignItems="flex-start"
                            justifyContent="flex-start"
                            sx={{}}
                          >
                            <Grid
                              container
                              direction="row"
                              alignItems="flex-start"
                              justifyContent="flex-start"
                            >
                              <Grid item xs={7} md={5}>
                                <Typography padding="1px">
                                  {"Cheque Date"}
                                </Typography>
                              </Grid>
                              <Grid item xs={5} md={7}>
                                {` :  ${row.chequeDate}`}
                              </Grid>
                              <Grid item xs={7} md={5}>
                                <Typography padding="1px">
                                  {"Application Number"}
                                </Typography>
                              </Grid>
                              <Grid item xs={5} md={7}>
                                {` :  ${row.applicationNum}`}
                              </Grid>
                              <Grid item xs={7} md={5}>
                                <Typography padding="1px">
                                  {"Cheque Amount"}
                                </Typography>
                              </Grid>
                              <Grid item xs={5} md={7}>
                                {` :  ${
                                  row.chequeAmt === "0"
                                    ? 0
                                    : parseInt(row.chequeAmt).toLocaleString(
                                        "en-IN"
                                      )
                                }`}
                              </Grid>
                              <Grid item xs={7} md={5}>
                                <Typography padding="1px">
                                  {"Return Reason"}
                                </Typography>
                              </Grid>
                              <Grid item xs={5} md={7}>
                                {` :  ${row.returnReason}`}
                              </Grid>
                              <Grid item xs={7} md={5}>
                                <Typography padding="1px">
                                  {"Charges"}
                                </Typography>
                              </Grid>
                              <Grid item xs={5} md={7}>
                                {` :  ${
                                  row.charges === "0"
                                    ? 0
                                    : parseInt(row.charges).toLocaleString(
                                        "en-IN"
                                      )
                                }`}
                              </Grid>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                    <Divider />
                  </React.Fragment>
                ))}
                {rows.length === 0 && (
                  <NoDataFound
                    message={"No Cheque Return Data Found."}
                    imageStyle={{
                      marginTop:
                        accordianOpen && window.innerHeight < 1000
                          ? "20px"
                          : "20%",
                    }}
                  />
                )}
              </Box>
            </Grid>
          </React.Fragment>
        )}
      </AccordianContainer>
      <Dialog
        open={open}
        fullScreen
        // onClose={handleDialogClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          <h4>{"Cheque Return Information"}</h4>
        </DialogTitle>
        <DialogContent>
          {
            <React.Fragment>
              <Paper sx={{ marginBottom: "8px", padding: "0px 16px 8px 16px" }}>
                <h4>{"Cheque Info"}</h4>
                <Grid container rowSpacing={0} columnSpacing={1}>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <CustomTextField
                      type="number"
                      label="Cheque Number"
                      variant="standard"
                      required={dlgInputMode}
                      disabled={!dlgInputMode}
                      value={formData.chequeNum}
                      onBlur={(e) => {
                        onChangeChequeNumber();
                      }}
                      inputProps={{
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        style: { textAlign: `left`, fontSize: "12px" },
                      }}
                      onChange={(event) => {
                        if (event.target.value.length <= 6) {
                          dispatch(
                            ChequeReturnReducerAction.updateChequeNumber(
                              event.target.value ? event.target.value : ""
                            )
                          );
                          const newValue = event.target.value;
                          setChequeNumErrorMsg(
                            newValue === null ||
                              newValue === undefined ||
                              newValue === ""
                              ? "Please Enter Cheque Number"
                              : newValue.length > 6 ||
                                newValue.length < 6 ||
                                String(newValue).includes(".") ||
                                Number(newValue) < 0 ||
                                !/^\d+$/.test(newValue)
                              ? "Please Enter Valid Cheque Number"
                              : ""
                          );
                        } else {
                          return;
                        }
                      }}
                    ></CustomTextField>
                    {chequeNumHasError && (
                      <p className="error">{chequeNumErrorMsg}</p>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <CustomAutoComplete
                      label="Voucher Number"
                      variant="standard"
                      disabled={!dlgInputMode}
                      type="text"
                      required={true}
                      autoCompleteValues={formData.voucherNumArray}
                      value={formData.voucherNum}
                      onChange={(e, value) => {
                        onChangeVoucherNum(value);
                      }}
                      onBlur={() => {
                        dispatch(
                          ChequeReturnReducerAction.updateVoucherNumTouchHandler(
                            true
                          )
                        );
                      }}
                    />
                    {voucherNumHasError && (
                      <p className="error">Please Select Voucher Number</p>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <CustomDateField
                      type="Cheque Date"
                      label="Cheque Date"
                      variant="standard"
                      disabled={true}
                      value={formData.chequeDate}
                    ></CustomDateField>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <CustomTextField
                      type="Application Number"
                      label="Application Number"
                      variant="standard"
                      disabled={true}
                      value={formData.applicationNum}
                      tooltip={formData.applicationNum}
                    ></CustomTextField>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <CustomTextField
                      type="Cheque Amount"
                      label="Cheque Amount"
                      variant="standard"
                      disabled={true}
                      value={
                        formData.chequeAmt === "0"
                          ? 0
                          : parseInt(formData.chequeAmt).toLocaleString("en-IN")
                      }
                      onChange={(event, value) => {
                        dispatch(
                          ChequeReturnReducerAction.updateChequeAmt(
                            event.target.value
                              ? event.target.value.replaceAll(",", "")
                              : 0
                          )
                        );
                      }}
                    ></CustomTextField>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <CustomDropDown
                      type="Return Reason"
                      label="Return Reason"
                      variant="standard"
                      value={formData.returnReason}
                      disabled={false}
                      dropDownValue={formData.returnReasonArray}
                      onBlur={() => {
                        dispatch(
                          ChequeReturnReducerAction.updateReturnReasonTouchHandler(
                            true
                          )
                        );
                      }}
                      onChange={(e) => {
                        dispatch(
                          ChequeReturnReducerAction.updateReturnReason(
                            e.target.value
                          )
                        );
                        const selectedReasonName = e.target.value;
                        const returnReasons =
                          store.getState().chequeReturn.data.returnReasonArray;
                        const filteredReason = returnReasons?.filter(
                          (record) => record.value === selectedReasonName
                        );
                        dispatch(
                          ChequeReturnReducerAction.updateReturnReasonCode(
                            filteredReason[0]?.name
                              ? filteredReason[0]?.name
                              : null
                          )
                        );
                      }}
                    />
                    {returnReasonHasError && (
                      <p className="error">Please Select Return Reason</p>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                    <CustomTextField
                      type="Charges"
                      label="Charges"
                      variant="standard"
                      disabled={true}
                      value={
                        formData.charges === "0"
                          ? 0
                          : parseInt(formData.charges).toLocaleString("en-IN")
                      }
                      onChange={(event, value) => {
                        dispatch(
                          ChequeReturnReducerAction.updateCharges(
                            event.target.value
                              ? event.target.value.replaceAll(",", "")
                              : 0
                          )
                        );
                      }}
                    ></CustomTextField>
                    {chargesHasError && (
                      <p className="error">Please Enter Charges</p>
                    )}
                  </Grid>
                </Grid>
              </Paper>
              {dlgbtnName === "OK" && (
                <ChequeReturnInfo dlgInputMode={dlgInputMode} />
              )}
            </React.Fragment>
          }
        </DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+Q" placement="top">
            <Button onClick={() => closeDialog()} ref={cancelRef}>
              CANCEL
            </Button>
          </Tooltip>
          <Tooltip title="Ctrl+K" placement="top">
            <Button
              disabled={
                formData.chequeNum === "" ||
                formData.chequeNum === undefined ||
                formData.chequeNum === null ||
                chequeNumHasError ||
                returnReasonHasError ||
                voucherNumHasError ||
                formData.returnReason === undefined ||
                formData.returnReason === "" ||
                formData.returnReason === null ||
                formData.voucherNum === undefined ||
                formData.voucherNum === "" ||
                formData.voucherNum === null
              }
              onClick={() =>
                dlgbtnName === "NEXT" ? setDlgBtnName("OK") : onDlgOkClick()
              }
              ref={okRef}
            >
              {dlgbtnName}
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
      <Dialog
        open={dialogOpen}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{dialogTitleMessage}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {dialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+Q" placement="top">
            <Button ref={cancelDialogRef} onClick={handleDialogClose}>
              Cancel
            </Button>
          </Tooltip>
          <Tooltip title="Ctrl+Y" placement="top">
            <Button ref={yesRef} onClick={onSaveButtonClickHandler}>
              Yes
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
      <Dialog
        open={chequeRealisedErrorDialogOpen}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Information"}</DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            sx={{ whiteSpace: "break-spaces !important" }}
          >
            {chequeRealisedErrorDialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+K" placement="top">
            <Button
              ref={chequeRealisedOkRef}
              onClick={() => {
                dispatch(ChequeReturnReducerAction.updateSaveBtnDisable(false));
                setChequeRealisedErrorDialogOpen(false);
              }}
            >
              OK
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={alert}
        autoHideDuration={6000}
        anchorOrigin={{ vertical, horizontal }}
        onClose={closeAlertHandler}
      >
        <Alert
          onClose={closeAlertHandler}
          severity={alertType}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </React.Fragment>
  );
};

export default ChequeReturnList;

const LoadActionBtn = (props) => {
  const [record, setRecord] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const req_mod_options = ["Edit", "Delete"];
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const modifyRef = useRef(null);
  const deleteRef = useRef(null);
  const dispatch = useDispatch();
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "chequeReturnList",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();

    if (event.ctrlKey) {
      if (charCode === "m") {
        modifyRef.current.click();
      } else if (charCode === "b") {
        deleteRef.current.click();
      }
    }
  };

  useLayoutEffect(() => {
    setRecord(props.record);
  }, [props.record]);

  useEffect(() => {
    setRecord(props.record);
  }, [props.record]);

  const handleIconClick = (value, record) => {
    handleClose();
    props.onMoreActionsClick(value, record);
  };

  const ITEM_HEIGHT = 48;
  return (
    <React.Fragment>
      {record.addRecord && (
        <div>
          <Tooltip title="More Actions">
            <IconButton
              aria-label="more"
              id="long-button"
              aria-controls={open ? "long-menu" : undefined}
              aria-expanded={open ? "true" : undefined}
              aria-haspopup="true"
              onClick={handleMenuClick}
            >
              <MoreVert sx={{ color: "#004A92", fontWeight: 700 }} />
            </IconButton>
          </Tooltip>
          <Menu
            id="long-menu"
            MenuListProps={{
              "aria-labelledby": "long-button",
            }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            PaperProps={{
              style: {
                maxHeight: ITEM_HEIGHT * 4.5,
                width: "100px",
              },
            }}
          >
            {req_mod_options.map((option, index) => (
              <MenuItem
                key={option}
                selected={option === "Pyxis"}
                onClick={() => handleIconClick(option, record)}
                ref={index === 0 ? modifyRef : deleteRef}
              >
                <IconButton size="small">
                  {(() => {
                    switch (index) {
                      case 0:
                        return (
                          <Tooltip title="Ctrl+M" placement="right">
                            <Edit
                              fontSize="small"
                              sx={{ color: "#004A92", fontWeight: 700 }}
                            />
                          </Tooltip>
                        );
                      case 1:
                        return (
                          <Tooltip title="Ctrl+B" placement="right">
                            <Delete
                              fontSize="small"
                              sx={{ color: "#004A92", fontWeight: 700 }}
                            />
                          </Tooltip>
                        );
                    }
                  })()}
                </IconButton>
                <Typography
                  color="#004A92"
                  variant="inherit"
                  component="div"
                  fontSize="14px"
                  fontWeight="inherit"
                >
                  {option}
                </Typography>
              </MenuItem>
            ))}
          </Menu>
        </div>
      )}
    </React.Fragment>
  );
};
